import { useJobNameModalState } from "app/pages/sales-intelligence/modules/crm-enrichment/hooks/useJobNameModalState";
import crmEnrichmentManageTrackingService from "app/pages/sales-intelligence/modules/crm-enrichment/services/tracking/trackingService";

import CrmEnrichmentJobNameModal from "../../../components/CrmEnrichmentJobNameModal/CrmEnrichmentJobNameModal";
import type { CrmEnrichmentJob } from "../../../types/types";
import useSfEnrichmentJobRenameMutation from "../query/mutations/useSfEnrichmentJobRenameMutation";

type SfEnrichmentJobRenameModalContainerProps = {
    job: CrmEnrichmentJob;
    onClose?: VoidFunction;
};

const SfJobRenameModalContainer = ({ job, onClose }: SfEnrichmentJobRenameModalContainerProps) => {
    const { isNameModalOpen, jobName, onSetJobName, onNameModalTrigger } = useJobNameModalState(job.name);

    const { name, id } = job;

    const { mutate: mutateRename, isPending: isLoadingRename } = useSfEnrichmentJobRenameMutation();

    const handleCloseModal = () => {
        onNameModalTrigger(false);
        onSetJobName(name);
        onClose?.();
    };

    const handleSaveJobName = (newName: string) => {
        crmEnrichmentManageTrackingService.trackRenameJob(newName, name, "salesforce");

        mutateRename(
            { jobId: id, name: newName },
            {
                onSuccess: () => onNameModalTrigger(false),
            },
        );
    };

    return (
        <CrmEnrichmentJobNameModal
            crmProvider="salesforce"
            jobName={jobName}
            isRenameMode
            isOpened={isNameModalOpen}
            isSubmitDisabled={!jobName.trim() || jobName === name}
            isSubmitLoading={isLoadingRename}
            onChangeJobName={onSetJobName}
            onSaveName={handleSaveJobName}
            onClose={handleCloseModal}
        />
    );
};

export default SfJobRenameModalContainer;
